// local
import { baseFetch } from '../../baseFetch';
import {
  UserSearchResponse,
  UserSearchResponseSchema,
  UserOffboardResponse,
  UserOffboardResponseSchema,
} from './users.schema';

export const searchUsers = (
  query: string,
  type: 'email' | 'name',
): Promise<UserSearchResponse> => {
  return baseFetch('internal-v2', '/users/search', UserSearchResponseSchema, {
    searchParams: {
      [type]: query,
      include_orgs: 'true',
    },
  });
};

export const offboardUser = (userId: number): Promise<UserOffboardResponse> => {
  return baseFetch(
    'internal-v2',
    `/users/${userId}/offboard`,
    UserOffboardResponseSchema,
    {
      method: 'POST',
    },
  );
};
